import React, { useEffect, useState } from 'react';
import {default as Logo} from '../../assets/icons/otra-vida-tattoo_logo.png';
import {default as CallIcon} from '../../assets/icons/call_icon.png';
import {default as EmailIcon} from '../../assets/icons/email_icon.png';
import * as _ from 'lodash';
import { NavLink } from 'react-router-dom';
import {default as ArrowUpIcon} from '../../assets/icons/arrow-up.png';
import anime from 'animejs';
import classnames from 'classnames';
import { Favorite, LocationOn } from '@material-ui/icons';
import { useAuth } from '../../contexts/auth.context';

const sorter = { Montag: 1, Dienstag: 2, Mittwoch: 3, Donnerstag: 4, Freitag: 5, Samstag: 6, Sonntag: 7 };
const sortDays = (arr) => [...arr].sort((a, b) => sorter[a] - sorter[b]);

const FooterComponent = () => {
    const [showToTop, setShowToTop] = useState(false);
    const {locations} = useAuth();

    useEffect(() => {
        const handleScroll = () => {
            setShowToTop(window.scrollY > 1200);
        };
        document.addEventListener('scroll', handleScroll);
        return () => document.removeEventListener('scroll', handleScroll);
    }, []);

    return <footer>
        <div className="top">
            <div className="address-box">
                <img src={Logo} alt="Logo"/>
                <p className="company-name">Otra Vida<br/>Tattoo & Piercing</p>
            </div>
            <div className="locations-container">
                {locations && locations.map((info, key) => {
                    return <div className="contact-box" key={key}>
                        {info && info.locationName && <div className="location-footer">
                            <LocationOn /> {info.locationName}
                        </div>}
                        <div className="contact-box-inner">
                            <div className="contact-info-col">
                                <div className="contact">
                                    <p>Inh: {info.owner.name} {info.owner.surname}</p>
                                </div>
                                {info && info.contact ? _.map(info.contact, (contact, key) => {
                                    if (!_.isNil(contact) && contact) {
                                        if (key === 'email') {
                                            return <div className="contact" key={key}>
                                                <img src={EmailIcon} alt="E-Mail - icon"/>
                                                <p><a href={"mailto:"+contact}>{contact}</a></p>
                                            </div>
                                        }
                                        if (key === 'phone') {
                                            return <div className="contact" key={key}>
                                                <img src={CallIcon} alt="Call - icon"/>
                                                <p><a href={"tel:"+contact}>{contact}</a></p>
                                            </div>
                                        }
                                    } else {
                                        return <div className="contact" key={key}>
                                            <p>😳 {key === 'phone' ? 'Telefon' : 'E-Mail'} nicht vorhanden</p>
                                        </div>
                                    }
                                }) : <div className="information-about-login">
                                    <h2>😳 Keine Kontaktdaten vorhanden</h2>
                                </div>}
                            </div>
                            {info && info.openHours && (
                                <div className="open-hours-col">
                                    <p className="open-hours-title">Öffnungszeiten</p>
                                    {_.map(info.openHours, (data, key) => {
                                        const selectedDays = data.days && !Array.isArray(data.days)
                                            ? sortDays(Object.keys(data.days))
                                                .filter(op => {
                                                    const day = data.days[op];
                                                    return day && day.value === true && String(day.index) === String(key);
                                                })
                                                .map(v => v.slice(0, 2))
                                                .join(', ')
                                            : '';
                                        return (
                                            <div className="open-hours-entry" key={key}>
                                                {selectedDays && <p className="days-label">{selectedDays}</p>}
                                                {data.allDayTime ? (
                                                    <p>{data.times.from} – {data.times.to}</p>
                                                ) : (
                                                    <>
                                                        <p>{data.times.morning.from} – {data.times.morning.to}</p>
                                                        <p>{data.times.afternoon.from} – {data.times.afternoon.to}</p>
                                                    </>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    </div>
                })}
            </div>
            <div className="navigation-box">
                <NavLink activeClassName="selected" to="/">Home</NavLink>
                <NavLink activeClassName="selected" to="/team">Team</NavLink>
                <NavLink activeClassName="selected" to="/gallery">Galerie</NavLink>
                <NavLink activeClassName="selected" to="/contact">Kontakt & Anfahrt</NavLink>
                <NavLink activeClassName="selected" to="/news">News</NavLink>
            </div>
        </div>
        <div className="bottom">
            <NavLink activeClassName="selected" to="/impressum">Impressum</NavLink>
            <NavLink activeClassName="selected" to="/privacy">Datenschutz</NavLink>
            <img src={ArrowUpIcon} className={classnames("go-top", {'show': showToTop})} alt="go-to-top" onClick={() => {
                const scrollElement = window.document.scrollingElement || window.document.body || window.document.documentElement;
                anime({
                    targets: scrollElement,
                    scrollTop: 0,
                    easing: 'cubicBezier(.3,.3,.56,1)',
                    duration: 3000
                });
            }}/>
            <p className="flex-box creators" onClick={() => window.open('https://www.instagram.com/trippy.pixels.team/')}>Made with <Favorite className="heart-beat-anim" /> from Trippy Pixels</p>
        </div>
    </footer>
}

export default FooterComponent;